<cc-top-bar [title]="'BLACKLIST.LABEL'">
  <a routerLink="/blacklist"
     routerLinkActive="primary-hover active"
     [routerLinkActiveOptions]="{ exact: true }">
    <cc-top-bar-item>
      <i class="material-icons">insert_drive_file</i>
    </cc-top-bar-item>
  </a>
  <a
    routerLink="/blacklist/choose/add"
    routerLinkActive="primary-hover active">
    <cc-top-bar-item>
      <i class="material-icons sm-down-boost-icon">publish</i>
      <span translate>BLACKLIST.ADD_CONTACTS.TITLE</span>
    </cc-top-bar-item>
  </a>
  <a
    routerLink="/blacklist/choose/remove"
    routerLinkActive="primary-hover active">
    <cc-top-bar-item>
      <i class="material-icons sm-down-boost-icon">publish</i>
      <span translate>BLACKLIST.REMOVE_CONTACTS.TITLE</span>
    </cc-top-bar-item>
  </a>
</cc-top-bar>
<router-outlet></router-outlet>

